import InputChoice from './InputChoice';

export default InputChoice;
